import _ from 'lodash';

import Aux from '../components/Hoc/Aux';
import Zip from '../components/Questions/Zip.jsx';
import Age from '../components/Questions/Age.jsx';
import Budget from '../components/Questions/Budget.jsx';
import EmployeeBudget from '../components/Questions/EmployeeBudget.jsx';
import EmployeePreference from '../components/Questions/EmployeePreference.jsx';
import Employees from '../components/Questions/Employees.jsx';
import Family from '../components/Questions/Family.jsx';
import Household from '../components/Questions/Household.jsx';
import Income from '../components/Questions/Income.jsx';
import Kids from '../components/Questions/Kids.jsx';
import Medicare from '../components/Questions/Medicare.jsx';
import Results from '../containers/Results/Results.jsx';
import ResultsBiz from '../containers/Results/ResultsBiz.jsx';
import ResultsBizLookAgain from '../containers/Results/ResultsBizLookAgain.jsx';
import ResultsCHP from '../containers/Results/ResultsCHP.jsx';
import ResultsEssential from '../containers/Results/ResultsEssential.jsx';
import ResultsMedicaid from '../containers/Results/ResultsMedicaid.jsx';
import ResultsMedicare from '../containers/Results/ResultsMedicare.jsx';
import ResultsMedicareWesternNY from '../containers/Results/ResultsMedicareWesternNY.jsx';
import Selection from '../components/Questions/Selection.jsx';
import Allowance from '../components/Questions/Allowance.jsx';

export const defaultQuizState = {
  'step': 1,
  'fieldValues': {
    'Age': '',
    'MetalLevel': '',
    'FullTimeEmployees': '',
    'FamilyType': '',
    'IncomeYearly': '',
    'KidsCount': '',
    'CostPreference': '',
    'MedicareAllowance': '',
    'OriginalFamilyType': '',
    'Quote': '',
    'TotalFamilySize': '',
    'ZipCode': '',
    'Location': {},
    'Medicare': false,
    'Medicaid': false,
    'Essential': false,
    'ResultsType': '',
    'QuizRoute': ''
  },
  'animate': '',
  'location': {},
  'inQuiz': true,
  'show': {}
};

const stepDefaults = {
  'home': {
    'class': Aux,
    'props': {},
    'reducer': '',
    'key': 'home'
  },
  'zip': {
    'class': Zip,
    'props': {},
    'reducer': 'updateZip',
    'key': 'zip'
  },
  'age': {
    'class': Age,
    'props': {},
    'reducer': 'updateAge',
    'key': 'age'
  },
  'medicare': {
    'class': Medicare,
    'props': {},
    'reducer': 'selectMedicare',
    'key': 'medicare'
  },
  'household': {
    'class': Household,
    'props': {},
    'reducer': 'updateHouseholdSize',
    'key': 'household'
  },
  'family': {
    'class': Family,
    'props': {},
    'reducer': 'selectFamilyType',
    'key': 'family'
  },
  'kids': {
    'class': Kids,
    'props': {},
    'reducer': 'updateKidsCount',
    'key': 'kids'
  },
  'income': {
    'class': Income,
    'props': {},
    'reducer': 'updateIncome',
    'key': 'income'
  },
  'budget': {
    'class': Budget,
    'props': {},
    'reducer': 'selectBudget',
    'key': 'budget'
  },
  'allowance': {
    'class': Allowance,
    'props': {},
    'reducer': 'selectAllowance',
    'key': 'allowance'
  },
  'employees': {
    'class': Employees,
    'props': {},
    'reducer': 'updateFullTimeEmployees',
    'key': 'employees'
  },
  'employeeBudget': {
    'class': EmployeeBudget,
    'props': {},
    'reducer': 'selectEmployeeBudget',
    'key': 'employeeBudget'
  },
  'employeePref': {
    'class': EmployeePreference,
    'props': {},
    'reducer': 'selectEmployeePref',
    'key': 'employeePref'
  },
  'results': {
    'class': Results,
    'props': {},
    'show': {},
    'reducer': 'postResults',
    'key': 'results'
  },
  'resultsBiz': {
    'class': ResultsBiz,
    'props': {},
    'show': {},
    'reducer': 'postResults',
    'key': 'resultsBiz'
  },
  'resultsBizLookAgain': {
    'class': ResultsBizLookAgain,
    'props': {},
    'show': {},
    'reducer': 'postResults',
    'key': 'resultsBizLookAgain'
  },
  'resultsMedicaid': {
    'class': ResultsMedicaid,
    'props': {},
    'show': {},
    'reducer': 'postResults',
    'key': 'resultsMedicaid'
  },
  'resultsMedicare': {
    'class': ResultsMedicare,
    'props': {medicarePage: 'medicarePage'},
    'show': {},
    'reducer': 'postResults',
    'key': 'resultsMedicare'
  },
  'resultsMedicareWesternNY': {
    'class': ResultsMedicareWesternNY,
    'props': {medicarePage: 'medicarePage'},
    'show': {},
    'reducer': 'postResults',
    'key': 'resultsMedicareWesternNY'
  },
  'resultsEssential': {
    'class': ResultsEssential,
    'props': {},
    'show': {},
    'reducer': 'postResults',
    'key': 'resultsEssential'
  },
  'resultsCHP': {
    'class': ResultsCHP,
    'props': {},
    'show': {},
    'reducer': 'postResults',
    'key': 'resultsCHP'
  },
  'selection': {
    'class': Selection,
    'props': {},
    'key': 'selection'
  }
};

export const quizPaths = {
  'individuals': {
    'introText': 'you',
    'steps': [
      stepDefaults.zip,
      stepDefaults.age,
      _.merge({}, stepDefaults.medicare, {
        'props': {
          'nextStepNoAnimate': '',
          'lookingForMedicare': '',
          'goToPreference': ''
        }
      }),
      stepDefaults.household,
      _.merge({}, stepDefaults.income, {
        'props': {
          'skipIncome': '',
          'checkMedicaidEssential': ''
        }
      }),
      stepDefaults.allowance,
      stepDefaults.budget,
      stepDefaults.results,
      stepDefaults.resultsCHP,
      stepDefaults.resultsMedicaid,
      stepDefaults.resultsEssential,
      stepDefaults.resultsMedicare,
      stepDefaults.resultsMedicareWesternNY
    ]
  },

  'families': {
    'introText': 'you and your family',
    'steps': [
      stepDefaults.family,
      stepDefaults.zip,
      stepDefaults.household,
      _.merge({}, stepDefaults.kids, {
        'props': {
          'nextStepNoAnimate': ''
        }
      }),
      stepDefaults.income,
      stepDefaults.budget,
      stepDefaults.results,
      stepDefaults.resultsCHP,
      stepDefaults.resultsMedicaid,
      stepDefaults.resultsEssential
    ]
  },

  'small-business': {
    'introText': 'your employees',
    'steps': [
      stepDefaults.employees,
      _.merge({}, stepDefaults.zip, {
        'props': {
          'type': 'biz'
        }
      }),
      stepDefaults.employeeBudget,
      stepDefaults.employeePref,
      stepDefaults.resultsBiz
    ]
  },

  'small-business-look-again': {
    'introText': 'your employees',
    'steps': [
      stepDefaults.employees,
      _.merge({}, stepDefaults.zip, {
        'props': {
          'type': 'biz'
        }
      }),
      stepDefaults.employeeBudget,
      stepDefaults.employeePref,
      stepDefaults.resultsBizLookAgain
    ]
  },

  'essential': {
    'introText': 'you',
    'steps': [
      stepDefaults.family,
      _.merge({}, stepDefaults.zip, {
        'props': {
          'type': 'essential'
        }
      }),
      stepDefaults.household,
      _.merge({}, stepDefaults.kids, {
        'props': {
          'nextStepNoAnimate': ''
        }
      }),
      _.merge({}, stepDefaults.income, {
        'props': {
          'type': 'essential',
          'checkMedicaidEssential': ''
        }
      }),
      stepDefaults.results,
      stepDefaults.resultsCHP,
      stepDefaults.resultsMedicaid,
      _.merge({}, stepDefaults.resultsEssential, {
        'props': {
          'title': 'Your CDPHP Essential Plan Quote'
        }
      })
    ]
  },

  'medicaid': {
    'introText': 'you',
    'steps': [
      stepDefaults.family,
      _.merge({}, stepDefaults.zip, {
        'props': {
          'type': 'medicaid'
        }
      }),
      stepDefaults.household,
      _.merge({}, stepDefaults.kids, {
        'props': {
          'nextStepNoAnimate': ''
        }
      }),
      _.merge({}, stepDefaults.income, {
        'props': {
          'type': 'medicaid',
          'checkMedicaidEssential': ''
        }
      }),
      stepDefaults.results,
      stepDefaults.resultsCHP,
      stepDefaults.resultsMedicaid,
      stepDefaults.resultsEssential
    ]
  },

  'medicare': {
    'introText': 'you',
    'steps': [
      stepDefaults.zip,
      stepDefaults.allowance,
      stepDefaults.budget,
      stepDefaults.resultsMedicare,
      stepDefaults.resultsMedicareWesternNY
    ]
  },

  'child-health-plus': {
    'introText': 'you',
    'steps': [
      stepDefaults.zip,
      stepDefaults.household,
      _.merge({}, stepDefaults.kids, {
        'props': {
          'nextStepNoAnimate': ''
        }
      }),
      stepDefaults.income,
      stepDefaults.resultsCHP
    ]
  },

  'individuals-families': {
    'introText': 'you',
    'steps': [
      stepDefaults.selection
    ]
  },

  'home': {
    'steps': []
  }
};

export const _getCountyByZip = (counties, zip) => {
  return (counties ? counties.find((obj) => (obj.Zip === zip)) : {});
};

const _fieldValuesMap = [ // DON'T CHANGE THE ORDER OF THESE ITEMS OR PRIOR QUOTE URLS WILL BREAK
  'Age', // only for individuals
  'FamilyType',
  'KidsCount',
  'TotalFamilySize',
  'ZipCode',
  'IncomeYearly',
  'FullTimeEmployees', // only needed for smb
  'MetalLevel', // only needed for smb
  'Budget',
  'Quote',
  'CostPreference', // only needed for smb and one other
  'ResultsType',
  'QuizRoute',
  'MedicareAllowance'
];

const _familyTypeMap = [ // DON'T CHANGE THE ORDER OF THESE ITEMS OR PRIOR QUOTE URLS WILL BREAK
  'Couple',
  'CoupleChildren',
  'ChildrenOnly',
  'IndividualChildren',
  'Individual'
];

const _quoteTypeMap = [ // DON'T CHANGE THE ORDER OF THESE ITEMS OR PRIOR QUOTE URLS WILL BREAK
  'individuals',
  'families',
  'small-business',
  'medicare',
  'medicaid',
  'essential',
  'child-health-plus'
];

export const _resultsTypeMap = [ // DON'T CHANGE THE ORDER OF THESE ITEMS OR PRIOR QUOTE URLS WILL BREAK
  'Results',
  'ResultsBiz',
  'ResultsCHP',
  'ResultsEssential',
  'ResultsMedicaid',
  'ResultsMedicare',
  'ResultsMedicareWesternNY',
  'ResultsBizLookAgain'
];

const fieldValuesToArray = (fieldValues) => {
  const arr = [];

  for (let i = 0; i < _fieldValuesMap.length; i++) {
    const key = _fieldValuesMap[i];
    const val = fieldValues[key];

    switch (key) {
      case 'FamilyType':
        arr[i] = _familyTypeMap.indexOf(val);
        break;

      case 'Quote':
        arr[i] = _quoteTypeMap.indexOf(val);
        break;

      case 'QuizRoute':
        arr[i] = _quoteTypeMap.indexOf(val);
        break;

      case 'ResultsType':
        arr[i] = _resultsTypeMap.indexOf(val);
        break;

      case 'ZipCode':
        arr[i] = val;
        break;

      default:
        const floatNum = _.isUndefined(val) ? -1 :
          _.isString(val) ? parseFloat(val.replace(/,/g, '')) : val;
        if (isNaN(floatNum)) arr[i] = 0;
        else arr[i] = floatNum;
        break;
    }
  }

  return arr;
};

export const encodeUrl = (fieldValues) => btoa(JSON.stringify(fieldValuesToArray(fieldValues)));

export const decodeUrl = (url) => {
  let arr = JSON.parse(atob(url));
  let decodedFieldValues = {};
  for (let i = 0; i < arr.length; i++) if (arr[i] !== -1) decodedFieldValues[_fieldValuesMap[i]] = arr[i];
  decodedFieldValues['FamilyType'] = decodedFieldValues['OriginalFamilyType'] = _familyTypeMap[decodedFieldValues['FamilyType']];
  decodedFieldValues['Quote'] = _quoteTypeMap[decodedFieldValues['Quote']];
  decodedFieldValues['QuizRoute'] = _quoteTypeMap[decodedFieldValues['QuizRoute']];
  decodedFieldValues['ResultsType'] = _resultsTypeMap[decodedFieldValues['ResultsType']];
  return decodedFieldValues;
};

export const sendAnalyticsOnQuestion = (route, component) => {
  let visitorType, eventLabel;
  let label = route.charAt(0).toUpperCase() + route.slice(1);

  switch (route) {
    case 'individuals':
      visitorType = 'Prospect - Individual Non-Medicare';
      eventLabel = label + ' - ' + component;
      break;

    case 'families':
      visitorType = 'Prospect - Family';
      eventLabel = label + ' - ' + component;
      break;

    case 'child-health-plus':
      visitorType = 'Prospect - CHP';
      eventLabel = label + ' - ' + component;
      break;

    case 'small-business':
      visitorType = 'Prospect - Small Group';
      eventLabel = label + ' - ' + component;
      break;

    case 'medicaid':
      visitorType = 'Prospect - Medicaid';
      eventLabel = label + ' - ' + component;
      break;

    case 'essential':
      visitorType = 'Prospect - Essential';
      eventLabel = label + ' - ' + component;
      break;

    case 'medicare':
      visitorType = 'Prospect - Medicare';
      eventLabel = label + ' - ' + component;
      break;

    case 'find-a-plan':
      eventLabel = label + ' - ' + component;
      break;
  }

  _recordAnalytics({
    visitorType,
    eventLabel
  });
};

const _recordAnalytics = ({visitorType, eventLabel}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    visitorType,
    'event': 'GAEvent',
    'eventCategory': 'View',
    'eventAction': 'Quiz',
    eventLabel
  });
  _updateCallRails();
};

const _updateCallRails = () => {
  console.log('callTrkFire');
  let callTrkFire = document.getElementById('calltrk');
  if (callTrkFire) {
    callTrkFire.remove();
  }
  let newScript = document.createElement('script');
  let inlineScript = document.createTextNode('CallTrk.swap();');
  newScript.setAttribute('id', 'calltrk');
  newScript.appendChild(inlineScript);
  document.getElementsByTagName('body')[0].appendChild(newScript);
};